module.exports = "/_next/static/images/c3633ee7439ce2783c16834d170bf4f9-phone-and-card@1x.png.webp";